/**
 * Tujuan   : Footer portal dengan ornamen batik dan informasi kontak/sosial
 * Caller   : Layout.js
 * Dependensi: assets/svg, Image, redux globalActions
 * Main Functions: Footer
 * Side Effects: dispatch getFooter saat data belum tersedia
 */
import { IcBatikAtas, IcBatikBawah } from "assets/svg";
import React, { useEffect } from "react";
import Image from "./Image";
import { useDispatch, useSelector } from "react-redux";
import { getFooter } from "utils/redux/global/globalActions";
import { Link } from "react-router-dom";

const Footer = () => {
  const dispatch = useDispatch();

  const { sosmed, general } = useSelector((state) => state?.global?.footer);

  useEffect(() => {
    if (!sosmed || !general) {
      dispatch(getFooter());
    }
  }, [sosmed, general]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className="flex flex-col text-white font-inter">
        <div className="bg-secondary relative">
          <img
            src={IcBatikAtas}
            alt=""
            className="absolute top-0 left-0"
            style={{ transform: "scale(0.6)", transformOrigin: "top left" }}
          />
          <img
            src={IcBatikBawah}
            alt=""
            className="absolute bottom-0 right-0"
            style={{ transform: "scale(0.6)", transformOrigin: "bottom right" }}
          />
          <div className="flex flex-col items-center justify-center gap-7 mt-48 md:mt-12 mb-48 md:mb-4">
            <div className="flex flex-row gap-16 ">
              {sosmed &&
                Object.keys(sosmed)?.map((key, ind) => {
                  const value = sosmed[key];
                  return (
                    <Link key={ind} to={value?.link} target="_blank">
                      <Image src={value?.icon} alt={key} className="w-5 h-5" />
                    </Link>
                  );
                })}
            </div>
            <hr className="h-1 w-1/2 bg-white border-0" />
            {/* <Image src={LogoFooter} alt="logo-footer" /> */}
            <div className="flex flex-col items-center gap-2 px-2 md:px-0">
              <div className="flex flex-row flex-wrap items-center md:divide-x">
                <div className="md:px-5">
                  Copyright © 2024 Pelindo Eprocurement
                </div>
                <div className="md:px-5">All Rights Reserved.</div>
              </div>
              <div className="flex flex-col flex-wrap gap-2 md:gap-0 md:items-center md:flex-row md:divide-x">
                {general &&
                  Object.keys(general)?.map((key, ind) => {
                    const value = general[key];
                    return (
                      <Link
                        key={ind}
                        to={value?.link}
                        target="_blank"
                        className="flex flex-row items-center md:px-2"
                      >
                        <Image
                          src={value?.icon}
                          alt={key}
                          className="w-5 h-5 mr-2"
                        />
                        <div>{value?.label}</div>
                      </Link>
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
